export default __webpack_public_path__ + "static/media/001-options-lines.1852bc1b.png";